import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { DataProvider } from './context/DataContext';
import { ThemeProvider } from './context/ThemeContext';
import StorefrontErrorBoundary from './components/StorefrontErrorBoundary';

const container = document.getElementById('root');

const app = (
  <React.StrictMode>
    <StorefrontErrorBoundary>
      <ThemeProvider>
        <DataProvider>
          <App />
        </DataProvider>
      </ThemeProvider>
    </StorefrontErrorBoundary>
  </React.StrictMode>
);

createRoot(container).render(app);
